<template>
  <div class="bi-layout compair-layout">
    <h1 class="mb-8">Webseiten Report</h1>
    <vs-tabs v-model="currTab">
      <vs-tab label="Besuche">
        <div class="bi-table-card mb-4 mt-2">
          <h3>
            Übersicht des Zeitraums von
            {{ formattedStartDate }} bis
            {{ formattedEndDate }}
          </h3>
          <DataInput
            class="px-2 inline-block"
            type="date"
            name="daterange"
            label="Zeitraum"
            :default-date="dateRange"
            :config="{
              altFormat: 'd.m.Y H:i',
              dateFormat: 'Y-m-d H:i',
              mode: 'range',
              defaultDate: dateRange
            }"
            @input="updateDates"
          />
          <table class="table stats-table">
            <thead>
              <tr>
                <th>Besuche</th>
                <th>Eindeutige Besuche</th>
                <th>Seiten pro Sitzung</th>
                <th>Durchschnittliche Sitzungsdauer</th>
                <th>Absprungrate</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="websiteReportOverview" class="overview">
                <td>{{ websiteReportOverview.visits }}</td>
                <td>{{ websiteReportOverview.uniqueVisits }}</td>
                <td>{{ websiteReportOverview.pagesPerSession.toFixed(2) }}</td>
                <td>{{ websiteReportOverview.sessionLength }}</td>
                <td>
                  {{
                    websiteReportOverview.dropRate.toLocaleString("de", {
                      style: "percent",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2">
            <BiCompareBox :max-y="maxY" @max-y-updated="e => onMaxY('a', e)" />
          </div>
          <div class="vx-col w-full lg:w-1/2">
            <BiCompareBox :max-y="maxY" @max-y-updated="e => onMaxY('b', e)" />
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Stellen">
        <p class="my-4">
          <b>Zeitraum auswählen:</b
          ><DataInput
            class="px-2 inline-block"
            type="date"
            name="daterange"
            :config="{
              altFormat: 'd.m.Y H:i',
              dateFormat: 'Y-m-d H:i',

              mode: 'range',
              defaultDate: dateRange
            }"
            @input="updateDates"
          />
        </p>
        <div class="vx-row">
          <div class="vx-col w-full xl:w-1/6 mb-4">
            <BiStatisticsCard
              icon="fa-percentage"
              data="applications"
              title="Bewerbungen"
              small
              type="ALL"
              :limit-days="startDate"
              :limit-stop="endDate"
            />
          </div>
          <div class="vx-col w-full xl:w-1/6 mb-4">
            <BiStatisticsCard
              icon="fa-percentage"
              data="applications"
              title="Bewerbungen (Facebook)"
              small
              type="FACEBOOK"
              :limit-days="startDate"
              :limit-stop="endDate"
            />
          </div>
          <div class="vx-col w-full xl:w-1/6 mb-4">
            <BiStatisticsCard
              icon="fa-percentage"
              data="applications"
              title="Bewerbungen (Facebook)"
              small
              type="GOOGLE"
              :limit-days="startDate"
              :limit-stop="endDate"
            />
          </div>
          <div class="vx-col w-full xl:w-1/6 mb-4">
            <BiStatisticsCard
              icon="fa-percentage"
              data="costPerApplication"
              title="Pries/Bewerbung"
              small
              type="ALL"
              :limit-days="startDate"
              :limit-stop="endDate"
            />
          </div>
          <div class="vx-col w-full xl:w-1/6 mb-4">
            <BiStatisticsCard
              icon="fa-percentage"
              data="costPerApplication"
              title="Pries/Bewerbung (Facebook)"
              small
              type="FACEBOOK"
              :limit-days="startDate"
              :limit-stop="endDate"
            />
          </div>
          <div class="vx-col w-full xl:w-1/6 mb-4">
            <BiStatisticsCard
              icon="fa-percentage"
              data="costPerApplication"
              title="Pries/Bewerbung (Google)"
              small
              type="GOOGLE"
              :limit-days="startDate"
              :limit-stop="endDate"
            />
          </div>
        </div>
        <div class="vx-row mt-4">
          <div class="vx-col w-full lg:w-1/2">
            <h2>
              Bewerbungseingänge des Zeitraums von
              {{ formattedStartDate }} bis {{ formattedEndDate }} ({{
                newApplications
              }})
            </h2>
            <BiTableCardApplications
              :start-date="startDate"
              :end-date="endDate"
              @retrieved="updateNewApplications"
            />
          </div>
          <div class="vx-col w-full lg:w-1/2">
            <h2>Bewerbungen Pro Nutzergruppe</h2>
            <BiTableCardUserGroups
              :start-date="startDate"
              :end-date="endDate"
              :number="1000"
            />
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Top 5">
        <p class="my-4">
          <b>Zeitraum auswählen:</b
          ><DataInput
            class="px-2 inline-block"
            type="date"
            name="daterange"
            :config="{
              altFormat: 'd.m.Y H:i',
              dateFormat: 'Y-m-d H:i',

              mode: 'range',
              defaultDate: dateRange
            }"
            @input="updateDates"
          />
        </p>
        <top-5 :start="startDate" :end="endDate"></top-5>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import BiCompareBox from "@/components/bi/BiGroupingCompareBox";
import DataInput from "@/components/ui/DataInput";
import Top5 from "../../../components/bi/Top5.vue";
import BiTableCardUserGroups from "@/components/bi/BiTableCardUserGroups.vue";
import BiTableCardApplications from "@/components/bi/BiTableCardApplications.vue";
import BiStatisticsCard from "@/components/bi/BiStatisticsCard.vue";

import moment from "moment";
import gql from "graphql-tag";

export default {
  components: {
    BiCompareBox,
    Top5,
    DataInput,
    BiTableCardUserGroups,
    BiTableCardApplications,
    BiStatisticsCard
  },
  data: () => ({
    maxValues: { a: 0, b: 0 },
    currTab: 0,
    rawStartDate: moment().subtract(30, "days"),
    rawEndDate: moment(),
    newApplications: 0,
    dateRange: [
      moment()
        .subtract(30, "days")
        .toISOString(),
      moment().toISOString()
    ]
  }),
  computed: {
    maxY() {
      return Math.max(this.maxValues["a"], this.maxValues["b"]);
    },
    formattedEndDate() {
      return moment(this.endDate).format("DD.MM.YYYY");
    },
    formattedStartDate() {
      return moment(this.startDate).format("DD.MM.YYYY");
    },
    endDate() {
      return moment(this.rawEndDate);
    },
    startDate() {
      return moment(this.rawStartDate);
    }
  },
  methods: {
    onMaxY(chartIdx, value) {
      this.maxValues[chartIdx] = value;
    },
    updateNewApplications(value) {
      this.newApplications = value;
    },
    updateDates(value) {
      if (value.includes(" bis ")) {
        const [from, to] = value.split(" bis ");
        this.dateRange = [moment(from).toISOString(), moment(to).toISOString()];
        console.log(this.dateRange);
      }
    }
  },
  apollo: {
    websiteReportOverview: {
      query: gql`
        query WebsiteReportOverview($start: Time!, $end: Time!) {
          websiteReportOverview(start: $start, end: $end) {
            visits
            uniqueVisits
            pagesPerSession
            sessionLength
            dropRate
          }
        }
      `,
      variables() {
        return {
          start: this.rawStartDate,
          end: this.rawEndDate
        };
      }
    }
  },
  applicantSources: {
    query: gql`
      query ApplicantSources($page: Int!, $size: Int) {
        applicantSources(page: $page, size: $size) {
          results {
            id
            name
          }
        }
      }
    `,
    variables() {
      return {
        page: 1,
        size: 1000 //all sources in one response
      };
    },
    update(data) {
      let sources = {};
      for (let source of data.applicantSources.results) {
        sources[source.id] = source.name;
      }
      return sources;
    }
  },
  watch: {
    dateRange(value) {
      this.rawStartDate = moment(value[0]);
      this.rawEndDate = moment(value[1]);
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/components/bi/main";
</style>
